import { isNil } from 'ramda';
import { IThunkActionCreator } from '../../types/store';
import { isArrayWithItems } from '../../utils';
import { getSelectedDirections } from '../../utils/stations';
import { changePopupSelectedStations, onChangeStationDirection } from './actions';

export const changeStations = (ids: number[], checked: boolean = true): IThunkActionCreator => {
  return (dispatch, getState) => {
    const {
      stations: { currentStations, directions, selectedStations, selectedDirection },
    } = getState();
    const nextSelectedStations = checked
      ? selectedStations.concat(ids)
      : selectedStations.filter(id => !ids.includes(id));

    dispatch(changePopupSelectedStations(nextSelectedStations));
    // Если станция в другом направлении, то переключаемся на это направление.
    if (checked && ids.length === 1) {
      const station = currentStations.find(({ id }) => id === ids[0]);
      if (station && !station.directions.includes(selectedDirection) && station.directions.length) {
        const directionModels = getSelectedDirections(directions, station.directions);
        const directionId = isArrayWithItems(directionModels) ? directionModels[0].id : undefined;

        if (!isNil(directionId)) {
          dispatch(onChangeStationDirection(directionId));
        }
      }
    }
  };
};
